import React, { ReactElement, PropsWithChildren, useEffect } from "react";
import useLanguageSelectionStyles, { LanguageSelectionClasses } from "./styles";
import { useTranslation } from "react-i18next";
import { ArrowBottomIcon, EnIcon, TrIcon } from "../../assets/img/svgicons";

type LanguagesData = {
  lang: string;
  icon: ReactElement;
  label: string;
  activeLang?: boolean;
};

export type LanguageSelectionProps = {
  languages: Array<LanguagesData>;
};

function LanguageSelection({
  languages = [{ lang: "", icon: <></>, label: "", activeLang: false }],
}: PropsWithChildren<LanguageSelectionProps>): ReactElement {
  // Statement
  const [openLanguageBox, setOpenLanguageBox] = React.useState(false);
  const [activeLanguage, setActiveLanguage] = React.useState(languages[0]);
  // Styles Hook Calling
  const useStyles: LanguageSelectionClasses = useLanguageSelectionStyles({
    openLanguageBox,
  });
  // Translation
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const openLanguageBoxHandler = () => setOpenLanguageBox((data) => !data);

  function changeLanguage(lang: string): void {
    openLanguageBoxHandler();
    i18n.changeLanguage(lang);
  }

  const activeLanguageFinder = (items: any) => {
    let element = items.find((data: any) => {
      return data.activeLang === true;
    });
    if (element) {
      setActiveLanguage(element);
    }
  };

  useEffect(() => {
    activeLanguageFinder(languages);
  });

  return (
    <div className={useStyles.translationBox}>
      {currentLang === activeLanguage.lang ? (
        <div
          className={useStyles.languageItemActive}
          onClick={() => openLanguageBoxHandler()}
        >
          {activeLanguage.icon}
          <span className={useStyles.languageText}>{activeLanguage.label}</span>
          <ArrowBottomIcon className={useStyles.arrowBottomIcon} />
        </div>
      ) : (
        <div
          className={useStyles.languageItem}
          onClick={() => openLanguageBoxHandler()}
        >
          <TrIcon width="21" />
          <span className={useStyles.languageText}>Turkish</span>
          <ArrowBottomIcon className={useStyles.arrowBottomIcon} />
        </div>
      )}
      <ul className={useStyles.languagesBox}>
        {currentLang === "en" ? (
          <li
            onClick={() => changeLanguage("tr")}
            className={useStyles.languageItemSecond}
          >
            <TrIcon width="21" />
            <span className={useStyles.languageText}>Turkish</span>
          </li>
        ) : (
          <li
            onClick={() => changeLanguage("en")}
            className={useStyles.languageItemClass}
          >
            <EnIcon />
            <span className={useStyles.languageText}>English</span>
          </li>
        )}
      </ul>
    </div>
  );
}
export default LanguageSelection;
